'use client';

import {
  createToaster,
  Toaster as ChakraToaster,
  ToastCloseTrigger,
  ToastDescription,
  ToastRoot,
  ToastTitle,
} from '@chakra-ui/react';

export const toaster = createToaster({
  placement: 'bottom-start',
  overlap: true,
  gap: 16,
});

const rootStyle: React.CSSProperties = {
  width: 'fit-content',
  maxWidth: 240,
  flexDirection: 'column',
  alignItems: 'flex-start',
};

export const Toaster = () => (
  <ChakraToaster width={rootStyle.maxWidth} toaster={toaster}>
    {(toast) => (
      <ToastRoot key={toast.id} style={rootStyle}>
        {toast.title && <ToastTitle>{toast.title}</ToastTitle>}
        {toast.description && (
          <ToastDescription>{toast.description}</ToastDescription>
        )}
        <ToastCloseTrigger />
      </ToastRoot>
    )}
  </ChakraToaster>
);
